<template><!-- svgo-optimised -->
<svg class="icon icon__chevron icon__chevron--right" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m14.32 12.018-6.284 6.16.84.822L16 12.018 8.84 5 8 5.823l6.32 6.194Z" fill="currentColor"/></svg>
</template>